module.exports = __webpack_public_path__ + "static/media/16UNODC18.2274af7b.jpg";